module.exports = __webpack_public_path__ + "img/recDashboardNodata.01c172d0.svg";